import OrthopedicMattresses from "../../components/pages/blog/orthopedic-mattresses-for-back-pain";

export default OrthopedicMattresses;
